export const HERO_IMG =
  "https://images.unsplash.com/photo-1678132446331-da900be50e27?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHw0fHxtaW5pbWFsaXN0JTIwbHV4dXJ5JTIwaG9tZSUyMGludGVyaW9yJTIwd2FybSUyMGxpZ2h0fGVufDB8fHx8MTc4NjY5NjE5M3ww&ixlib=rb-4.1.0&q=85";

export const MANIFESTO_IMG =
  "https://images.unsplash.com/photo-1628744876497-eb30460be9f6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwxfHxtaW5pbWFsaXN0JTIwbHV4dXJ5JTIwaG9tZSUyMGludGVyaW9yJTIwd2FybSUyMGxpZ2h0fGVufDB8fHx8MTc4NjY5NjE5M3ww&ixlib=rb-4.1.0&q=85";

export const CHAPTERS = [
  {
    no: "01",
    word: "Page",
    meaning: "a story, inspiration & creativity",
    body: "Every object begins as a page — an unwritten idea, a spark of inspiration. We design pieces that invite you to author your own space.",
  },
  {
    no: "02",
    word: "Shier",
    meaning: "elegance, sophistication & exclusivity",
    body: "Restraint is our signature. Considered materials, quiet detail and a sophistication that feels exclusive without ever raising its voice.",
  },
  {
    no: "03",
    word: "Casa",
    meaning: "home, in Spanish & Italian",
    body: "Home is the final chapter and the point of it all. Warmth you can touch — the place where luxury finally learns to relax.",
  },
];

export const EMBROIDERY = [
  {
    id: "soleil",
    name: "Soleil",
    tag: "Celestial",
    desc: "Hand-embroidered sun in indigo wool with a golden face — a little warmth that never sets.",
    img: "https://customer-assets-lqy194kg.emergentagent.net/job_luxury-hampers-20/artifacts/6f1eu2jo_WhatsApp%20Image%202026-06-22%20at%203.23.14%20PM%20%283%29.jpeg",
  },
  {
    id: "xoxo",
    name: "Hugs & Kisses",
    tag: "Love notes",
    desc: "A playful tic-tac-toe of tufted hearts and letters — romance stitched by hand.",
    img: "https://customer-assets-lqy194kg.emergentagent.net/job_luxury-hampers-20/artifacts/n75lmhfm_WhatsApp%20Image%202026-06-22%20at%203.23.14%20PM%20%284%29.jpeg",
  },
  {
    id: "wildflower",
    name: "Wildflower",
    tag: "In bloom",
    desc: "A crewel-work bouquet in saffron, sage and sky — a garden that stays in season all year.",
    img: "https://customer-assets-lqy194kg.emergentagent.net/job_luxury-hampers-20/artifacts/wlp6lgxe_WhatsApp%20Image%202026-06-22%20at%203.23.14%20PM.jpeg",
  },
];

export const CANDLE_TYPES = [
  {
    id: "pillar",
    name: "Pillar Candles",
    desc: "Free-standing, slow-burning columns that anchor a table or mantel with a soft, steady glow.",
    scents: ["Sandalwood", "Oud", "Amber Musk"],
    img: "https://images.unsplash.com/photo-1636714528228-f469eefb3eef?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwxfHxwaWxsYXIlMjBjYW5kbGVzJTIwd2FybSUyMG5ldXRyYWx8ZW58MHx8fHwxNzg2NzAyMTA4fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "jar",
    name: "Jar & Tin Candles",
    desc: "Scented soy poured into amber glass and brushed tins — a considered fragrance for every room.",
    scents: ["Vanilla Bean", "Fig & Cedar", "Sea Salt"],
    img: "https://images.unsplash.com/photo-1612293905607-b003de9e54fb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwxfHxzY2VudGVkJTIwamFyJTIwY2FuZGxlJTIwYW1iZXIlMjBnbGFzc3xlbnwwfHx8fDE3ODY3MDIxMDh8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "tealight",
    name: "Tealights & Votives",
    desc: "The little ones — scattered across a table, they turn any evening into an occasion.",
    scents: ["Rose", "Jasmine", "Lavender"],
    img: "https://images.unsplash.com/photo-1528351655744-27cc30462816?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwyfHx0ZWFsaWdodCUyMHZvdGl2ZSUyMGNhbmRsZXMlMjBnbG93fGVufDB8fHx8MTc4NjcwMjEwOHww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "mercury",
    name: "Mercury Glass Votive",
    desc: "Poured into hand-tinted mercury glass with a jewel-like ombré finish — soulful light, even unlit.",
    scents: ["Ocean Mist", "Bergamot", "White Tea"],
    fit: "contain",
    bgClass: "bg-gradient-to-b from-[#3a6f6f] to-[#123236]",
    img: "https://customer-assets-lqy194kg.emergentagent.net/job_luxury-hampers-20/artifacts/nbzienix_candle-removebg-preview.png",
  },
];

export const LOOK_OPTIONS = {
  cushion: [
    { id: "soleil", label: "Soleil (Sun)", img: "https://customer-assets-lqy194kg.emergentagent.net/job_luxury-hampers-20/artifacts/6f1eu2jo_WhatsApp%20Image%202026-06-22%20at%203.23.14%20PM%20%283%29.jpeg" },
    { id: "xoxo", label: "Hugs & Kisses", img: "https://customer-assets-lqy194kg.emergentagent.net/job_luxury-hampers-20/artifacts/n75lmhfm_WhatsApp%20Image%202026-06-22%20at%203.23.14%20PM%20%284%29.jpeg" },
    { id: "wildflower", label: "Wildflower", img: "https://customer-assets-lqy194kg.emergentagent.net/job_luxury-hampers-20/artifacts/wlp6lgxe_WhatsApp%20Image%202026-06-22%20at%203.23.14%20PM.jpeg" },
  ],
  candle: [
    { id: "pillar", label: "Pillar · Sandalwood", img: "https://images.unsplash.com/photo-1636714528228-f469eefb3eef?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwxfHxwaWxsYXIlMjBjYW5kbGVzJTIwd2FybSUyMG5ldXRyYWx8ZW58MHx8fHwxNzg2NzAyMTA4fDA&ixlib=rb-4.1.0&q=85" },
    { id: "jar", label: "Jar · Vanilla Bean", img: "https://images.unsplash.com/photo-1612293905607-b003de9e54fb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwxfHxzY2VudGVkJTIwamFyJTIwY2FuZGxlJTIwYW1iZXIlMjBnbGFzc3xlbnwwfHx8fDE3ODY3MDIxMDh8MA&ixlib=rb-4.1.0&q=85" },
    { id: "tealight", label: "Votives · Rose", img: "https://images.unsplash.com/photo-1528351655744-27cc30462816?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwyfHx0ZWFsaWdodCUyMHZvdGl2ZSUyMGNhbmRsZXMlMjBnbG93fGVufDB8fHx8MTc4NjcwMjEwOHww&ixlib=rb-4.1.0&q=85" },
    { id: "mercury", label: "Mercury · Ocean Mist", img: "https://customer-assets-lqy194kg.emergentagent.net/job_luxury-hampers-20/artifacts/nbzienix_candle-removebg-preview.png" },
  ],
  vase: [
    { id: "rounded", label: "Rounded Table Vase", img: "https://images.unsplash.com/photo-1774364830987-d18b6b063ab7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwyfHxjZXJhbWljJTIwdGFibGUlMjB2YXNlJTIwbmV1dHJhbCUyMGRlY29yfGVufDB8fHx8MTc4NjcwMjEwOHww&ixlib=rb-4.1.0&q=85" },
    { id: "ivory", label: "Ivory Sculptural Vase", img: "https://images.unsplash.com/photo-1633000116322-d7f5cb7d3ebb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwyfHxjZXJhbWljJTIwdmFzZSUyMHNjZW50ZWQlMjBjYW5kbGUlMjBlbGVnYW50fGVufDB8fHx8MTc4NjY5NjE5M3ww&ixlib=rb-4.1.0&q=85" },
    { id: "claytrio", label: "Clay Trio", img: "https://images.unsplash.com/photo-1631125915902-d8abe9225ff2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxfHxjZXJhbWljJTIwdmFzZSUyMGVkaXRvcmlhbCUyMHN0aWxsJTIwbGlmZXxlbnwwfHx8fDE3ODY2OTcwNTd8MA&ixlib=rb-4.1.0&q=85" },
  ],
};

export const LOOK_PRESETS = [
  { id: "festive", label: "Festive", sel: { cushion: "soleil", candle: "jar", vase: "claytrio" } },
  { id: "diwali", label: "Diwali", sel: { cushion: "soleil", candle: "pillar", vase: "ivory" } },
  { id: "wedding", label: "Wedding", sel: { cushion: "wildflower", candle: "jar", vase: "rounded" } },
  { id: "calm", label: "Calm", sel: { cushion: "wildflower", candle: "tealight", vase: "ivory" } },
  { id: "neutral", label: "Neutral", sel: { cushion: "xoxo", candle: "pillar", vase: "rounded" } },
];

export const SHOWPIECES = [
  { id: "lovebirds", name: "Golden Lovebirds", tag: "Ceramic", span: "md:col-span-4", desc: "A pair of glossy gold birds — a quiet symbol of togetherness for shelf or console.", img: "https://customer-assets-lqy194kg.emergentagent.net/job_luxury-hampers-20/artifacts/0e6tgov2_p13_10.jpeg" },
  { id: "herd", name: "The Golden Herd", tag: "Resin", span: "md:col-span-4", desc: "Three elephants in polished gold — fortune, strength and family, sculpted together.", img: "https://customer-assets-lqy194kg.emergentagent.net/job_luxury-hampers-20/artifacts/v4cz20g1_p15_07.png" },
  { id: "buddha", name: "Serene Buddha", tag: "Handcrafted", span: "md:col-span-4", desc: "A meditating Buddha in ivory and gold leaf — stillness for any corner of the home.", img: "https://customer-assets-lqy194kg.emergentagent.net/job_luxury-hampers-20/artifacts/orlc1x2j_p06_11.jpeg" },
  { id: "mothercalf", name: "Mother & Calf", tag: "Ivory & Gold", span: "md:col-span-6", desc: "An elephant mother lifting her calf, finished in pearl-white and gold on a wooden base.", img: "https://customer-assets-lqy194kg.emergentagent.net/job_luxury-hampers-20/artifacts/1m4p6dp0_p18_11.jpeg" },
  { id: "deer", name: "Origami Deer", tag: "Sculptural", span: "md:col-span-6", desc: "A faceted, geometric deer pair in soft champagne — modern lines with a warm metallic sheen.", img: "https://customer-assets-lqy194kg.emergentagent.net/job_luxury-hampers-20/artifacts/5rknknyj_p08_11.png" },
];

export const CATEGORIES = [
  {
    id: "cushions",
    name: "Cushion Covers",
    tag: "Texture & touch",
    desc: "Hand-embroidered covers in natural weaves, tactile and tonal.",
    img: "https://customer-assets-lqy194kg.emergentagent.net/job_luxury-hampers-20/artifacts/n75lmhfm_WhatsApp%20Image%202026-06-22%20at%203.23.14%20PM%20%284%29.jpeg",
  },
  {
    id: "candles",
    name: "Candles",
    tag: "Scent & glow",
    desc: "Slow-burning, softly scented — an atmosphere in wax.",
    img: "https://images.unsplash.com/photo-1603905179139-db12ab535ca9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHxjZXJhbWljJTIwdmFzZSUyMHNjZW50ZWQlMjBjYW5kbGUlMjBlbGVnYW50fGVufDB8fHx8MTc4NjY5NjE5M3ww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "vases",
    name: "Ceramic Table Vases",
    tag: "Form & stillness",
    desc: "Sculptural table ceramics that hold light as beautifully as blooms.",
    img: "https://images.unsplash.com/photo-1774364830987-d18b6b063ab7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwyfHxjZXJhbWljJTIwdGFibGUlMjB2YXNlJTIwbmV1dHJhbCUyMGRlY29yfGVufDB8fHx8MTc4NjcwMjEwOHww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "coasters",
    name: "Beaded Coasters",
    tag: "Table & detail",
    desc: "Hand-beaded rose coasters with a golden trim — a jewel-like finish for every cup.",
    img: "https://customer-assets-lqy194kg.emergentagent.net/job_luxury-hampers-20/artifacts/de4xw6uq_ChatGPT%20Image%20Aug%2023%2C%202026%2C%2007_22_54%20PM.png",
  },
];

export const HAMPERS = [
  {
    id: "occasion",
    name: "Occasion Hampers",
    desc: "Diwali, weddings, housewarmings, birthdays — curated for the moment that matters.",
    img: "https://images.unsplash.com/photo-1592903297149-37fb25202dfa?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBnaWZ0JTIwaGFtcGVyJTIwYm94JTIwcmliYm9uJTIwZWFydGh5fGVufDB8fHx8MTc4NjY5NjE5M3ww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "corporate",
    name: "Corporate Hampers",
    desc: "Gifting at scale, without losing the personal touch. Branded, refined, remembered.",
    img: "https://images.unsplash.com/photo-1668127039849-c5dd95be3fa5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBnaWZ0JTIwaGFtcGVyJTIwYm94JTIwcmliYm9uJTIwZWFydGh5fGVufDB8fHx8MTc4NjY5NjE5M3ww&ixlib=rb-4.1.0&q=85",
  },
];

export const ESSENCE = {
  title: "The Essence Collection",
  edition: "Diwali Edition",
  intro:
    "A limited festive drop — three tiers of curated gifting, each blending our hand-embroidered decor with brass diyas, potlis and treats. Wrapped, ready, and made to be remembered.",
  tiers: [
    {
      id: "casa-edit",
      no: "I",
      name: "The Casa Edit",
      level: "Accessible Luxury",
      desc: "Our everyday-elegant edit — an embroidered cushion cover, brass diyas, gold potlis and festive treats in a handwoven basket.",
      items: ["Embroidered cushion cover", "Brass diya set", "Gold potli of treats", "Ceramic bud vase", "Nazar amulet"],
      img: "https://customer-assets-lqy194kg.emergentagent.net/job_luxury-hampers-20/artifacts/39t57hx8_THE%20CASA%20EDIT.jpeg",
    },
    {
      id: "curated-prestige",
      no: "II",
      name: "The Curated Prestige",
      level: "Refined Luxury",
      desc: "A considered, natural-luxe basket — a signature sun cushion, artisanal ceramics, dried pampas and gourmet nuts in organza.",
      items: ["Signature 'Soleil' cushion", "Ceramic vase pair", "Dried pampas", "Gourmet nuts", "Nazar amulet"],
      img: "https://customer-assets-lqy194kg.emergentagent.net/job_luxury-hampers-20/artifacts/qg6108bv_WhatsApp%20Image%202026-07-26%20at%202.01.44%20PM.jpeg",
    },
    {
      id: "casa-signature",
      no: "III",
      name: "The Casa Signature",
      level: "Signature Luxury",
      desc: "Our flagship — two embroidered cushion covers, a glass scented candle, two beaded coasters, a ceramic vase, a peacock urli and dry fruits, styled to perfection.",
      items: ["2 embroidered cushion covers", "Glass scented candle", "2 beaded coasters", "Ceramic vase", "Peacock urli", "Dry fruits"],
      img: "https://customer-assets-lqy194kg.emergentagent.net/job_luxury-hampers-20/artifacts/5r24jmgk_ChatGPT%20Image%20Aug%2023%2C%202026%2C%2006_57_44%20PM.png",
    },
  ],
};

export const OCCASIONS = [
  "Diwali", "Wedding", "Housewarming", "Birthday", "Anniversary", "Corporate", "Just Because",
];

export const HAMPER_ITEMS = [
  { id: "cushion", label: "Cushion Cover" },
  { id: "candle", label: "Scented Candle" },
  { id: "vase", label: "Ceramic Vase" },
  { id: "diffuser", label: "Reed Diffuser" },
  { id: "coasters", label: "Stone Coasters" },
  { id: "throw", label: "Woven Throw" },
  { id: "trinket", label: "Trinket Dish" },
  { id: "card", label: "Personalised Card" },
];
